import { render, staticRenderFns } from "./CNCMovementPanel.vue?vue&type=template&id=251c93d6&scoped=true"
import script from "./CNCMovementPanel.vue?vue&type=script&lang=ts"
export * from "./CNCMovementPanel.vue?vue&type=script&lang=ts"
import style0 from "./CNCMovementPanel.vue?vue&type=style&index=0&id=251c93d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c93d6",
  null
  
)

export default component.exports